import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';

import { useShadowRoot } from './ShadowRootContext';
import { textStyles } from './TextStyles';
import { cn } from './cn';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipArrow = TooltipPrimitive.Arrow;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    compact?: boolean;
    usesPortal?: boolean;
  }
>(({ className, sideOffset = 4, compact, usesPortal, ...props }, ref) => {
  const { container } = useShadowRoot();

  const content = (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={textStyles.body({
        color: 'inherit',
        size: compact ? 'sm' : 'md',
        className: cn(
          'z-[5000] max-w-[260px] overflow-hidden bg-bg-strong-primary text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          compact
            ? 'rounded-md px-1.5 pb-[3px] pt-px'
            : 'rounded-lg px-2.5 py-1.5',
          className,
        ),
      })}
      {...props}
    />
  );

  if (usesPortal === false) {
    return content;
  }

  return (
    <TooltipPrimitive.Portal container={container}>
      {content}
    </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
};
